import { Box, SxProps } from "@mui/system";
import React from "react";

const AppEmph = ({children, sx = {}}: {children: React.ReactNode, sx?: SxProps}) => <Box component="span" sx={Object.assign({ fontWeight: 500 }, sx)}>{children}</Box>
export default AppEmph;